import React, { useContext, useEffect } from "react";

import {AddressSuggestions} from "react-dadata";
import {observer} from "mobx-react-lite";
import '../../css/basket.css';
import {Context} from "../..";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ru } from 'date-fns/locale';
import { format } from 'date-fns';


const BasketCheckout = observer(({ customerData, setCustomerData, errors, isFormValid }) => {
    const {user} = useContext(Context)

/*    useEffect(() => {
        setCustomerData(prev => ({
          ...prev,
          city: customerData.address.data.city,
          street: customerData.address.data.street_with_type,
          house: customerData.address.data.house + customerData.address.data.block_type + customerData.address.data.block,
          flat: customerData.address.data.flat
        }));
      }, [customerData.address]);*/

// обработчик ошибок до ПРР 

/*const handleChange = (e) => {
    const { id, value } = e.target;

    // Обработка вложенного поля recipient
    if (id in customerData.recipient) {
        setCustomerData((prevData) => ({
            ...prevData,
            recipient: {
                ...prevData.recipient,
                [id]: value,
            },
        }));
    } else {
        // Для остальных полей, например address, city и т.п.
        setCustomerData((prevData) => ({
            ...prevData,
            [id]: value,
        }));
    }
}; */
const handleChange = (e) => {
  const { id, value } = e.target;
  const keys = id.split('.');

  setCustomerData((prevData) => {
    const updated = { ...prevData };
    let current = updated;

    // Копируем вложенные объекты по пути, кроме последнего ключа
    for (let i = 0; i < keys.length - 1; i++) {
      current[keys[i]] = { ...current[keys[i]] };
      current = current[keys[i]];
    }

    // Устанавливаем новое значение последнего ключа
    current[keys[keys.length - 1]] = value;

    return updated;
  });

  // НЕ трогаем errors, т.к. их обновление отдельно
};

      
   // console.log("customerData for BasketCheckout", customerData)

    return (
        <>
        {!isFormValid && (
            <div className="alert alert-danger mt-3" role="alert">
              Необходимо заполнить все обязательные поля!
            </div>
          )}
            <h3 className="mb-4">1. Личные данные</h3>
            <div className="d-flex align-items-center">
                <InputGroup className="mb-3">
                    <InputGroup.Text>Ф.И.О.</InputGroup.Text>
                    <Form.Control
                        required
                        aria-label="Default"
                        aria-describedby="inputGroup-sizing-default"
                        type="text"
                        id="recipient.firstName"
                        value={customerData.recipient.firstName}
                        onChange={handleChange}
                        isInvalid={!!errors.recipient.firstName}
                        
                    />
                </InputGroup>
            </div>
            <div className="d-flex align-items-center">
                <InputGroup className="mb-3 me-4">
                    <InputGroup.Text>E-mail</InputGroup.Text>
                    <Form.Control
                        required
                        aria-label="Default"
                        aria-describedby="inputGroup-sizing-default"
                        type="text"
                        id="recipient.email"
                        value={customerData.recipient.email}
                        onChange={handleChange}
                        isInvalid={!!errors.recipient.email}
                    />
                </InputGroup>
                <InputGroup className="mb-3">
                    <InputGroup.Text>Телефон</InputGroup.Text>
                    <Form.Control
                        required
                        aria-label="Default"
                        aria-describedby="inputGroup-sizing-default"
                        type="text"
                        id="recipient.phone"
                        value={customerData.recipient.phone}
                        onChange={handleChange}
                        isInvalid={!!errors.recipient.phone}
                    />
                </InputGroup>
            </div>

            <h3 className="mb-4 mt-4">2. Адрес доставки</h3>

            {user.hasRoleShop && (
                <div>
                    <div className="d-flex align-items-center">    
                        <InputGroup className="d-flex mb-3">
                            <InputGroup.Text>Стоимость доставки</InputGroup.Text>
                            <Form.Control
                                required
                                aria-label="Default"
                                aria-describedby="inputGroup-sizing-default"
                                type="text"
                                id="priceDost"
                                value={customerData.priceDost}
                                onChange={handleChange}
                                placeholder="Цифрами сколько при доставке забрать с клиента"
                                isInvalid={!!errors.priceDost}
                            />
                        </InputGroup>
                    </div>
                    <Row>
                        <Col xs={12} md={6} className="mb-3 mb-md-0">     
                            <InputGroup className="d-flex mb-3">
                                <InputGroup.Text>Разгрузка</InputGroup.Text>
                                <Form.Select
                                    required
                                    id="prr.code"
                                    value={customerData.prr.code}
                                    onChange={handleChange}
                                    isInvalid={!!errors.prr?.code}
                                >
                                    <option value="none">Доставка до подъезда</option>
                                    <option value="lift">С подъёмом (лифт)</option>
                                    <option value="stairs">С подъёмом (нет лифта) </option>
                                </Form.Select>
                            </InputGroup>
                        </Col>
                        <Col xs={12} md={6}>       
                            <InputGroup>
                                <InputGroup.Text>Дата доставки</InputGroup.Text>
                                    <div className="form-select">
                                    <DatePicker
                                        locale={ru}
                                        selected={customerData.deliveringDate ? new Date(customerData.deliveringDate) : null}
                                        onChange={(date) =>
                                          setCustomerData((prev) => ({
                                            ...prev,
                                            deliveringDate: date ? format(date, "yyyy-MM-dd'T'HH:mm:ss"): null,
                                          }))
                                        }
                                        placeholderText="Выберите дату"
                                        className={`custom-datepicker-btn form-control ${errors.deliveringDate ? 'is-invalid' : ''}`}
                                        dateFormat="yyyy-MM-dd'T'HH:mm:ss"
                                        minDate={new Date()}
                                        id="deliveringDate"                                        
                                        
                                        isInvalid={!!errors.deliveringDate}
                                        filterDate={(date) => {
                                            const day = date.getDay();
                                            return day !== 0 && day !== 6; // 0 = Sunday, 6 = Saturday
                                        }}
                                    />    
                                        </div>                           
                            </InputGroup>
                        </Col>
                     </Row>
                </div>
            )}

            <div className="d-flex align-items-center">   
                <InputGroup className="mb-3">
                    <InputGroup.Text>Адрес</InputGroup.Text>
                    <AddressSuggestions
                        containerClassName={"form-control"}
                        token="a199d8110c08dd0d938a91b102aefa65fcf11239"
                        value={customerData.address}
                        onChange={(newAddress) => 
                            setCustomerData(prev => ({
                              ...prev,
                              address: newAddress,
                            }))
                          }                        
                        suggestionClassName="my-suggestion"
                        inputProps={{
                            className: `w-100 border-0`,
                            style: { outline: 'none', boxShadow: 'none' } // Убираем рамку через inline-стили
                    }}
                    
                    
                        // inputProps={{onChange: (e) => {
                        //         // setAddress({value: e.target.value})
                        //
                        // }}}
                    />
                </InputGroup>
            </div>
            <Row className="mb-3">
                <Col xs={12} md={6} className="mb-3 mb-md-0">     
                    <InputGroup>
                        <InputGroup.Text>Город</InputGroup.Text>
                        <Form.Control
                            required
                            aria-label="Default"
                            aria-describedby="inputGroup-sizing-default"
                            type="text"
                            id="city"
                            value={customerData.address.data.city || ''}                        
                            readOnly // <--- поле нельзя редактировать
                            style={{ backgroundColor: '#e9ecef' }} // Bootstrap-серый для readonly-полей
                        />
                    </InputGroup>
                </Col>
                <Col xs={12} md={6}>
                  <InputGroup>
                    <InputGroup.Text>Улица</InputGroup.Text>
                    <Form.Control
                        required
                        aria-label="Default"
                        aria-describedby="inputGroup-sizing-default"
                        type="text"
                        id="street"
                        value={customerData.address.data.street_with_type || ''}
                        onChange={handleChange}
                        readOnly // <--- поле нельзя редактировать
                        style={{ backgroundColor: '#e9ecef' }} // Bootstrap-серый для readonly-полей
                    />
                </InputGroup>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs={12} md={6} className="mb-3 mb-md-0">
                <InputGroup>
                  <InputGroup.Text>Дом/Корпус</InputGroup.Text>
                  <Form.Control
                    required
                    aria-label="Default"
                    aria-describedby="inputGroup-sizing-default"
                    type="text"
                    id="house"
                    value={
                          (customerData.address.data.house || '') +
                          (customerData.address.data.block_type || '') +
                          (customerData.address.data.block || '')
                        }
                    onChange={handleChange}                    
                    readOnly // <--- поле нельзя редактировать
                    style={{ backgroundColor: '#e9ecef' }} // Bootstrap-серый для readonly-полей
                  />
                </InputGroup>
              </Col>
              <Col xs={12} md={6}>
                <InputGroup>
                  <InputGroup.Text>Подъезд</InputGroup.Text>
                  <Form.Control
                    type="text"
                    id="padik"
                    value={customerData.padik}
                    onChange={handleChange}
                  />
                </InputGroup>
              </Col>
            </Row>
            <Row className="mb-3">
                <Col xs={12} md={6} className="mb-3 mb-md-0">
                   <InputGroup>
                        <InputGroup.Text>Квартира/Офис</InputGroup.Text>
                        <Form.Control
                            // required
                            aria-label="Default"
                            aria-describedby="inputGroup-sizing-default"
                            type="text"
                            id="flat"
                            value={customerData.address.data.flat}
                            onChange={handleChange}
                        />
                    </InputGroup>
                </Col>
                <Col xs={12} md={6}>
                    <InputGroup>
                        <InputGroup.Text>Домофон</InputGroup.Text>
                        <Form.Control
                            required
                            aria-label="Default"
                            aria-describedby="inputGroup-sizing-default"
                        />
                    </InputGroup>
                </Col>
            </Row>
            <h3 className="mb-4">3. Комментарий к заказу</h3>
            <div className="d-flex align-items-center">
                <Form className="w-100">
                    <Form.Group className="mb-3">
                        <Form.Control 
                                as="textarea" 
                                rows={3} 
                                id="comment"
                                value={customerData.comment}
                                onChange={handleChange}
                        />
                    </Form.Group>
                </Form>
            </div>
            {/*<h3 className="mb-4 mt-4">4. Как вам будет удобнее оплатить заказ?</h3>
            <div className="d-flex align-items-center">
                <Form className="mb-4">
                    {['radio'].map((type) => (
                        <div key={`inline-${type}`} className="mb-3">
                            <Form.Check
                                inline
                                label="Онлайн"
                                name="group1"
                                type={type}
                                id={`inline-${type}-1`}
                            />
                            <Form.Check
                                inline
                                label="Картой при получении"
                                name="group1"
                                type={type}
                                id={`inline-${type}-2`}
                            />
                            <Form.Check
                                inline
                                label="Наличными при получении"
                                name="group1"
                                type={type}
                                id={`inline-${type}-3`}
                            />
                        </div>
                    ))}
                </Form>
            </div>*/}
        </>
    );
});

export default BasketCheckout;